'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Host$() {
  this.c77 = null;
  this.c78 = false;
  this.c75 = null;
  this.c76 = false;
  this.c7b = null;
  this.c7c = false;
  this.c79 = null;
  this.c7a = false;
  this.c7f = null;
  this.c7d = null;
  this.c7e = false;
  $n_Lpresto_types$Host$ = this;
  this.c7f = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_s_util_matching_Regex__T__sci_Seq__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_matching_Regex(), "^(?=.{1,255}$)(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\\.[A-Za-z0-9-]{1,63})*$", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
}
export { $c_Lpresto_types$Host$ as $c_Lpresto_types$Host$ };
$p = $c_Lpresto_types$Host$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Host$;
/** @constructor */
function $h_Lpresto_types$Host$() {
}
export { $h_Lpresto_types$Host$ as $h_Lpresto_types$Host$ };
$h_Lpresto_types$Host$.prototype = $p;
$p.crA = (function() {
  if ((!this.c78)) {
    this.c77 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c78 = true;
  }
  return this.c77;
});
$p.va = (function() {
  if ((!this.c76)) {
    this.c75 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c76 = true;
  }
  return this.c75;
});
$p.a2v = (function() {
  if ((!this.c7c)) {
    this.c7b = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c7c = true;
  }
  return this.c7b;
});
$p.adp = (function() {
  if ((!this.c7a)) {
    this.c79 = new $c_Lpresto_types$Host$$anon$75(this);
    this.c7a = true;
  }
  return this.c79;
});
$p.a2A = (function() {
  if ((!this.c7e)) {
    this.c7d = new $c_Lpresto_types$Host$$anon$76(this);
    this.c7e = true;
  }
  return this.c7d;
});
$p.a2O = (function(str) {
  return (((str.indexOf(".") | 0) !== (-1)) && this.c7f.ae4(str));
});
var $d_Lpresto_types$Host$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Host$, "presto.types$Host$", ({
  a0O: 1,
  D: 1
}));
export { $d_Lpresto_types$Host$ as $d_Lpresto_types$Host$ };
var $n_Lpresto_types$Host$;
function $m_Lpresto_types$Host$() {
  if ((!$n_Lpresto_types$Host$)) {
    $n_Lpresto_types$Host$ = new $c_Lpresto_types$Host$();
  }
  return $n_Lpresto_types$Host$;
}
export { $m_Lpresto_types$Host$ as $m_Lpresto_types$Host$ };
/** @constructor */
function $c_Lpresto_types$Host$$anon$76(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Host$$anon$76 as $c_Lpresto_types$Host$$anon$76 };
$p = $c_Lpresto_types$Host$$anon$76.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Host$$anon$76;
/** @constructor */
function $h_Lpresto_types$Host$$anon$76() {
}
export { $h_Lpresto_types$Host$$anon$76 as $h_Lpresto_types$Host$$anon$76 };
$h_Lpresto_types$Host$$anon$76.prototype = $p;
$p.bn = (function(it) {
  try {
    $m_Lpresto_types$Host$();
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().ak(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bN = (function(text) {
  return ($m_Lpresto_types$Host$().a2O(text) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(text) : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "Host inv\u00e1lido")));
});
$p.bJ = (function(t) {
  return this.bn(t);
});
var $d_Lpresto_types$Host$$anon$76 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Host$$anon$76, "presto.types$Host$$anon$76", ({
  a0Q: 1,
  K: 1
}));
export { $d_Lpresto_types$Host$$anon$76 as $d_Lpresto_types$Host$$anon$76 };
/** @constructor */
function $c_Lpresto_types$Host$$anon$75(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Host$$anon$75 as $c_Lpresto_types$Host$$anon$75 };
$p = $c_Lpresto_types$Host$$anon$75.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Host$$anon$75;
/** @constructor */
function $h_Lpresto_types$Host$$anon$75() {
}
export { $h_Lpresto_types$Host$$anon$75 as $h_Lpresto_types$Host$$anon$75 };
$h_Lpresto_types$Host$$anon$75.prototype = $p;
$p.ct = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.cr = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.co = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.cp = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.cB = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.cs = (function(other) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.b2 = (function(x, y) {
  $m_Lpresto_types$Host$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__compareTo__T__I(x, y);
});
var $d_Lpresto_types$Host$$anon$75 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Host$$anon$75, "presto.types$Host$$anon$75", ({
  a0P: 1,
  N: 1,
  a: 1,
  Q: 1,
  S: 1,
  V: 1
}));
export { $d_Lpresto_types$Host$$anon$75 as $d_Lpresto_types$Host$$anon$75 };
//# sourceMappingURL=presto.types$-Host$.js.map
